<!-- v-if="openPopup === true" -->
<template>
    <div class="bg">
        <h1 class="title-form">Мадлоба, генецвале!</h1>
        <div class="container">
            <div v-if="openPopup === true">
                <p class="checkLabel">{{ popupText }}</p>
                <div v-if="urlPopup">
                    <p class="checkLabel">Поделитесь впечатлениями о нашем грузинском доме</p>
                    <div class="url_btns">
                        <a class="link" href="https://yandex.ru/maps/org/dzhos/119724909058/reviews/?ll=46.046067%2C51.526038&z=14" target="_blank">
                            <img class="icon" src="https://play-lh.googleusercontent.com/1mLrH4xJXqsydfnXDgXyarwVUaX_PtWm1v9KkaRKorfCTLlzGKlrj3stkEsCYpZi9kU=w240-h480-rw" alt="yandex_icon"/>
                            Яндекс
                        </a>
                        <a class="link" href="https://www.google.com/maps?q=%D0%B4%D0%B6%D0%BE%D1%81&gs_lcrp=EgZjaHJvbWUqDAgAECMYJxjjAhiKBTIMCAAQIxgnGOMCGIoFMg8IARAuGCcYrwEYxwEYigUyBwgCEAAYgAQyBggDEEUYPTIGCAQQRRhBMgYIBRBFGD0yBggGEEUYQTIGCAcQRRhB0gEHODM5ajBqNKgCALACAA&um=1&ie=UTF-8&sa=X&ved=2ahUKEwiwy4L9t4SCAxVgFhAIHS0kDlgQ_AUoAnoECAQQBA" target="_blank">
                            <img class="icon" src="https://w7.pngwing.com/pngs/543/934/png-transparent-google-app-logo-google-logo-g-suite-google-text-logo-circle.png" alt="google_icon"/>  
                            Google
                        </a>
                        <a class="link" href="https://2gis.ru/saratov/firm/70000001039906844" target="_blank">
                            <img class="icon" src="data:image/png;base64,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" alt="google_icon"/>
                            2GIS
                        </a>
                    </div>
                </div>
            </div>
            <form @submit.prevent="sendResult" :class="displayClass">
                <label for="range-grade">
                    Насколько вы готовы порекомендовать дом Джоса своим дорогим друзьям и родным?
                </label>
                <p class="checkLabel">10 — великолепно! Буду рекомендовать всем! 1 — ужасно! никому не рекомендую...</p>
                <v-slider
                    id="range-grade"
                    color="#000"
                    track-color="#b2b2b2"
                    :step="0.1"
                    :min="0.1"
                    :max="1"
                    thumb-label="always"
                    v-model="rangeInputValue"
                    class="mt"
                >
                    <template v-slot:thumb-label="{ modelValue }">
                        {{ modelValue * 10 }}
                    </template>
                </v-slider>
                <div class="checkDiv align-between">
                    <p class="checkLabel">1</p>
                    <p class="checkLabel">10</p>
                </div>
            <!-- badthings section -->
                <div v-if="rangeInputValue < 0.7" class="mb">
                    <label for="range-grade">
                        Что больше всего повлияло на вашу оценку, дарагие генацвале? Можно выбрать несколько ответов.
                    </label>
                    <v-checkbox
                      v-for="item in checkboxArr"
                        :key="item.id"
                        :label="item.value"
                        :value="item.value"
                        v-model="checkboxInputs"
                        style="height: 20px, margin-bottom: 20px, opacity: 0"
                    ></v-checkbox>
                </div>
            <!-- comment section -->
                <div>
                    <label for="comment" class="mb">
                        {{ rangeInputValue === 0.9 || rangeInputValue === 1 ?
                          "Место для любошвильных слов" :
                          0.7 <= rangeInputValue && rangeInputValue <= 0.8 ?
                          "Чего нам не хватило до оценки 10?" :
                          "Комментарий"
                        }}
                    </label>
                    <textarea
                        v-model="textareaValue"
                        name="text-comment"
                        id="comment"
                        cols="30"
                        rows="2"
                        class="mb"
                    ></textarea>
                </div>
            <!-- phone section -->
                <div v-if="rangeInputValue < 0.9">
                    <label for="comment" class="mb">
                        Место для вашего номера телефонидзэ
                    </label>
                    <input
                        v-model="phoneInputValue"
                        type="text"
                        name="phone-input"
                        id="phone"
                        class="mb"
                        :required="rangeInputValue <= 0.6 ? true : false"
                    />
                </div>
                <button type="submit" class="btn">Отправить</button>
            </form>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios'
  
export default {
    data () {
      return {
        popupText: 'Спасибо, что помогаете дому Джоса стать лучше❤️',
        openPopup: false,
        urlPopup: false, //  true
        rangeInputValue: 0.5,
        checkboxInputs: [],
        textareaValue: '',
        phoneInputValue: '',
        checkboxArr: [
          { id: 'drinks', value: 'Некачественные блюда и напитки' },
          { id: 'assortment', value: 'Маленький ассортимент' },
          { id: 'drinks', value: 'Ошибка в заказе: принесли лишнее блюдо или не донесли, что заказывали' },
          { id: 'hostes', value: 'Плохая работа хостес: бронирование стола, как встретили' },
          { id: 'long_time', value: 'Долго несли блюдо, принесли холодное блюдо, не было блюда, которое я хотел заказать' },
          { id: 'service', value: 'Слишком навязчивое обслуживание' },
          { id: 'congratulation', value: 'Меня не поздравили' },
          { id: 'expensive', value: 'Цена — слишком дорого' },
          { id: 'lighting', value: 'Темно в зале/слишком яркое освещение' },
          { id: 'loud', value: 'Слишком шумно, слишком громко' },
          { id: 'nursery', value: 'Скудное наполнение детской комнаты, не нравится работа аниматора' },
          { id: 'other', value: 'Другое — напишу в комментарии' },
        ]
      }
    },
    mounted () {
      setTimeout(() => {
        this.rangeInputValue = 0.6
      }, 400)
  
      setTimeout(() => {
        this.rangeInputValue = 0.5
      }, 800)
    },
    methods: {
      // async 
      sendResult () {
        let msgForTG = ''
  
        if (0.8 < this.rangeInputValue) {
          msgForTG += 'Положительный отзыв'
          msgForTG += `\n`
          msgForTG += `Оценка посетителя: <b>${ this.rangeInputValue * 10 }</b>\n`
          msgForTG += `Комментарий: <b>${ this.textareaValue === '' ? "Гость не оставил комментарий" : this.textareaValue }</b>\n`
  
          this.popupText = 'Джос, счастлив стать вашим другом! До новых встреч в атмосфере веселидзэ!❤️'
          this.urlPopup = true
        }
  
        if (0.6 < this.rangeInputValue &&  this.rangeInputValue < 0.9) {
          msgForTG += 'Нейтральный отзыв'
          msgForTG += `\n`
          msgForTG += `Оценка посетителя: <b>${ this.rangeInputValue * 10 }</b>\n`
          msgForTG += `Комментарий: <b>${ this.textareaValue === '' ? "Гость не оставил комментарий" : this.textareaValue }</b>\n`
          msgForTG += `Телефон для связи: <b>${ this.phoneInputValue === "" ? 'Гость не оставил свой телефон' : this.phoneInputValue }</b>\n`
  
          this.popupText = 'Спасибо, что помогаете дому Джоса стать лучше❤️'
        }
  
        if (this.rangeInputValue <= 0.6) {
          msgForTG += 'Отрицательный отзыв'
          msgForTG += `\n`
          msgForTG += `Оценка посетителя: <b>${ this.rangeInputValue * 10 }</b>\n`
          msgForTG += `Что не понравилось:\n <b>${ this.checkboxInputs.join(';\n') }</b>\n`
          msgForTG += `Комментарий: <b>${ this.textareaValue === '' ? "Гость не оставил комментарий" : this.textareaValue }</b>\n`
          msgForTG += `Телефон для связи: <b>${ this.phoneInputValue }</b>\n`
  
          this.popupText = 'Спасибо, что помогаете дому Джоса стать лучше❤️'
        }
  
        msgForTG += `\n`
  
        const date = new Date()
        msgForTG += `Время отправки отзыва: <b>${ date.getHours() }:${date.getMinutes()}</b>\n`
        msgForTG += `Дата отправки заявки: <b>${ date.getDate() }-${ date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1 }-${ date.getFullYear() }</b>`
        console.log(msgForTG)
  
        // await 
        axios.post(process.env.VUE_APP_URL_TELEGRAM, {
          chat_id: process.env.VUE_APP_CHAT_ID,
          parse_mode: 'html',
          text: msgForTG
        })
  
        const formData = {
          feedback: 0.8 < this.rangeInputValue ? 'Положительный отзыв' : 0.6 < this.rangeInputValue &&  this.rangeInputValue < 0.9 ? 'Нейтральный отзыв' : 'Отрицательный отзыв',
          grade: this.rangeInputValue * 10,
          problems: 0.8 < this.rangeInputValue ? 'Нет проблем' : 0.6 < this.rangeInputValue &&  this.rangeInputValue < 0.9 ? 'Проблема описана в комментарии' : `${this.checkboxInputs.join(';\n')}`,
          comment: this.textareaValue,
          phone: this.phoneInputValue === "" ? 'Гость не оставил свой телефон' : this.phoneInputValue,
          time: `${ date.getHours() }:${date.getMinutes()}`,
          date: `${ date.getDate() }-${ date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1 }-${ date.getFullYear() }`
        }
  
        // await 
        axios.post(process.env.VUE_APP_GOOGLE_TABLE, formData).then((response) => console.log(response.data))
        document.querySelector('.bg').style.height = '100vh';
        this.openPopup = true
        
  
        this.rangeInputValue = 0.5
        this.checkboxInputs = []
        this.textareaValue = ''
        this.phoneInputValue = ''
      }
    },
    computed: {
      displayClass () {
        if (this.openPopup === true) {
          return 'none'
        } else {
          return 'display'
        }
      }
    },
    watch: {
      phoneInputValue () {
        this.phoneInputValue = this.phoneInputValue.replace(/[a-zа-яё]/gi, '')
  
        this.phoneInputValue[0] === '7' ? 
          this.phoneInputValue = this.phoneInputValue[0].replace('7', '8') :
          this.phoneInputValue = this.phoneInputValue
  
        if (this.phoneInputValue.length > 11) {
          this.phoneInputValue = ''
        }
      }
    }
}
</script>
  
<style scoped>
    .bg {
        background-image: url('../assets/img/podloshkajpeg.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
        min-height: 100%;
        max-height: fit-content;
        width: 100%;
        padding: 50px 0px;
    }

    .link {
        color: #000000;
        text-decoration: none;
        font-size: 30px;
        display: flex;
        align-items: center;
        gap: 10px
    }
    
    .link:hover {
        color: #64DCC3;
    }
    
    .url_btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
    }
    
    .icon {
        width: 30px;
        height: 30px;
        border: 0;
        border-radius: 50px;
    }
    
    @media (max-width: 500px) {
        .url_btns {
        flex-direction: column;
        gap: 10px;
        }
    }
    
    .title-form {
        font-size: 100px;
        text-align: center;
        font-family: 'Amatic SC', cursive;
        text-transform: uppercase;
    }
    
    .container {
        width: 700px;
        margin: 20px auto 50px;
        background-color: white;
        padding: 40px;
        box-sizing: border-box;
        border: 0;
        border-radius: 60px;
    }
    
    @media (max-width: 700px) {
        .container {
        width : 500px
        }
    
        .title-form {
        font-size: 80px;
        }
    }
    
    @media (max-width: 500px) {
        .container {
        width : 340px
        }
    
        .title-form {
        font-size: 48px;
        }
    }
    
    .comment {
        border: 2px solid black;
        border-radius: 20px;
    }
    
    label {
        display: block;
        color: rgb(0, 0, 0);
        font-family: "PT Sans Narrow";
        font-size: 26px;
        font-weight: 700;
    }
    
    .mb {
        margin-bottom: 20px;
    }
    .mt {
        margin-top: 26px;
    }
    
    #comment, #phone {
        color: rgb(0, 0, 0);
        border: 2px solid rgb(0, 0, 0);
        background-color: rgb(255, 255, 255);
        border-radius: 15px;
        font-size: 22px;
        font-weight: 500;
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
    }
    
    #comment {
        height: 85px;
    }
    
    #phone {
        height: 55px;
    }
    
    form {
        transition: all 5s ease-out;
    }
    
    .btn {
        padding: 0px 15px;
        display: block;
        width: 220px;
        font-weight: 600;
        height: 50px;
        margin-left: auto;
        margin-right: auto;
        color: #000000;
        border-radius: 30px;
        font-size: 22px;
        font-family: PT Sans Narrow;
        cursor: pointer;
        background-color: #e6ff00;
    }
    
    .checkLabel, .v-label {
        font-size: 22px;
        font-weight: 400;
        font-family: PT Sans Narrow;
        color: #000000 !important;
        opacity: 1;
    }
    
    .v-input__details {
        display: none;
    }
    
    .v-alert__content {
        font-family: PT Sans Narrow;
        color: #000000;
        font-size: 22px;
    }
</style>